import { UPDATE_SOP_REVIEW_STATUS_API } from "../../constants/api";
import { ConfluencePage, TableRowData } from "../../types/dataType";
import axios from "../fetch/fetch";

export const updateSOPDocumentStatusAPI = async (documentId: string, status: string): Promise<TableRowData> => {
    const body = {
        documentId: documentId,
        status: status,
    };
    const res = await axios.put(UPDATE_SOP_REVIEW_STATUS_API, body);
    return res.data;
};
